import { PropsWithChildren, useContext } from 'react';

import useLayoutServices from '../hooks/use-layout-services';

import { Outlet } from "react-router-dom";

import AuthContext from "../store/auth-context";
import AppContext from "../store/app-context";

import Geolocation from "../components/Shared/Geolocation/Geolocation";
import Connectivity from "../components/Connectivity/Connectivity";
import Overlay from "../components/Overlay/Overlay";
import Loading from "../components/Overlay/Loading/Loading";
import Message from "../components/Overlay/Message/Message";
import Dialog from "../components/Overlay/Dialog/Dialog";
import Menu from "../components/Overlay/Menu/Menu";
import LabelReader from "../components/Overlay/LabelReader/LabelReader";
import Login from "../components/Overlay/Login/Login";

import Header from "../components/Header/Header";

type layoutProps = {};

const ScannerLayout = (props: PropsWithChildren<layoutProps>) => {
    const appCtx = useContext(AppContext);
    const authCtx = useContext(AuthContext);

    useLayoutServices();

    const isAuthenticated = authCtx.isAuthenticated;

    return (
        <div className="scanner-root">
            <Geolocation />
            <Overlay>
                <Loading />
                <Message />
                <Dialog />
                <Menu />
                <LabelReader />
                <Login />
            </Overlay>
            {isAuthenticated && appCtx.init && <Header />}
            <main className={!isAuthenticated || !appCtx.init ? 'hide' : ''}>
                <div>
                    <Outlet />
                    {props.children}
                </div>
            </main>
            <Connectivity />
        </div>
    );
};

export default ScannerLayout;

type data = {
    request: any,
    params: any
};

export async function appLoader(data: data) {
    return data;
}
